import { render } from "./UsoPracticasMultiple.vue?vue&type=template&id=9f208aa4&scoped=true"
import script from "./UsoPracticasMultiple.vue?vue&type=script&lang=js"
export * from "./UsoPracticasMultiple.vue?vue&type=script&lang=js"

import "./UsoPracticasMultiple.vue?vue&type=style&index=0&id=9f208aa4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f208aa4"]])

export default __exports__